// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3FYQP","rootCenter":"LoadMoreObserver_rootCenter__1NIYG","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__34Kgz"};